// extracted by mini-css-extract-plugin
module.exports = {"faqWrapper":"bJZqa"};